export const TAX_CODE_OTHER_EXEMPT = {
    label: 'No',
    value: '99999',
};
export const TAX_CODE_FULLY_TAXABLE = {
    label: 'Yes',
    value: '',
};
export const DEFAULT_INPUT_DATE_FORMAT = 'yyyy-MM-dd';
export const ISO_8601_FULL_FORMAT = "yyyy-MM-dd'T'HH:mm:ss.SSSX";
export const TIME_ZONES_ABBREVIATIONS = ['PST', 'GMT', 'MST', 'EST'];
//# sourceMappingURL=OcrConstants.js.map